<div class="loading-spinner" [ngClass]="{ fullSize: fullSize }">
  <mat-spinner diameter="40" strokeWidth="3" color=""></mat-spinner>
</div>
